/** billing screen strings (EN source of truth + VI); spread into the main dictionaries */

export const billingEn = {
  'billing.title': 'Billing',
  'billing.subtitle': 'Credit balance, credit packs and the history of how this workspace spends credits.',

  'billing.overview.heading': 'Plan & credits',
  'billing.balance.total': 'Total balance',
  'billing.balance.purchased': 'Purchased',
  'billing.balance.free': 'Free',
  'billing.balance.credits': '{count} credits',
  'billing.balance.hint': 'Free credits are spent first. Purchased credits do not expire.',
  'billing.balance.error': 'Could not load the credit balance.',

  'billing.buy.heading': 'Buy credits',
  'billing.buy.popular': 'Most popular',
  'billing.buy.credits': '{count} credits',
  'billing.buy.bonus': '+{count} bonus',
  'billing.buy.buy': 'Buy now',
  'billing.buy.buyNamed': 'Buy {name}',
  'billing.buy.redirecting': 'Redirecting…',
  'billing.buy.packsError': 'Failed to load credit packs. Please refresh the page.',
  'billing.buy.noPacks': 'No credit packs are currently available.',
  'billing.buy.footer': 'Card payments are processed securely by Polar. Credits are non-refundable and do not expire.',
  'billing.buy.footerWithTransfer':
    'Card payments (USD) are processed securely by Polar; VietQR bank transfers (VND) are confirmed automatically by SePay. Credits are non-refundable and do not expire.',
  'billing.buy.payCard': 'Card (USD)',
  'billing.buy.payCardNamed': 'Pay for {name} by card in USD',
  'billing.buy.payTransfer': 'Bank transfer VietQR (VND)',
  'billing.buy.payTransferNamed': 'Pay for {name} by VietQR bank transfer in VND',
  'billing.buy.priceVnd': 'or {price} by bank transfer',

  'billing.sepay.title': 'Bank transfer: {name}',
  'billing.sepay.creating': 'Creating your payment order…',
  'billing.sepay.createFailed': 'Could not create the payment order.',
  'billing.sepay.unconfigured': 'Bank transfer is not available right now.',
  'billing.sepay.retry': 'Try again',
  'billing.sepay.scan': 'Scan the QR code with your banking app, or transfer manually with the details below. Keep the transfer content exactly as shown so we can match your payment.',
  'billing.sepay.qrAlt': 'VietQR code to pay {amount}',
  'billing.sepay.bank': 'Bank',
  'billing.sepay.account': 'Account number',
  'billing.sepay.accountName': 'Account name',
  'billing.sepay.amount': 'Amount',
  'billing.sepay.content': 'Transfer content',
  'billing.sepay.copy': 'Copy {label}',
  'billing.sepay.copied': 'Copied',
  'billing.sepay.expiresIn': 'Expires in {time}',
  'billing.sepay.expired': 'This order has expired. If you already transferred, your credits will still be added; otherwise create a new order.',
  'billing.sepay.waiting': 'Waiting for your transfer… This updates automatically.',
  'billing.sepay.statusError': 'Could not check the payment status. Retrying…',
  'billing.sepay.paidTitle': 'Payment received',
  'billing.sepay.paidBody': '{credits} credits were added to your balance.',
  'billing.sepay.newOrder': 'Create a new order',
  'billing.sepay.done': 'Done',

  'billing.banner.sandboxTitle': 'Sandbox mode',
  'billing.banner.sandboxBody': 'Checkouts use the Polar sandbox, so no real charges are made. Use a sandbox test card.',
  'billing.banner.successTitle': 'Payment successful',
  'billing.banner.successBody': "Your credits will appear in your balance shortly. We'll refresh automatically.",
  'billing.banner.cancelTitle': 'Checkout cancelled',
  'billing.banner.cancelBody': 'No charge was made. Pick a pack below to try again.',
  'billing.banner.unconfiguredTitle': 'Payment system not configured',
  'billing.banner.unconfiguredBody': 'The payment provider is unavailable. Please contact support.',
  'billing.banner.checkoutFailed': 'Checkout failed',
  'billing.banner.noCheckoutUrl': 'Checkout did not return a payment link. Please try again.',

  'billing.history.heading': 'Credit history',
  'billing.history.transactions': 'Transactions',
  'billing.history.purchases': 'Purchases',
  'billing.history.filterLabel': 'Transaction type',
  'billing.history.filterAll': 'All types',
  'billing.history.type.deduct': 'Usage',
  'billing.history.type.purchase': 'Purchase',
  'billing.history.type.free_grant': 'Free credits',
  'billing.history.type.refund': 'Refund',
  'billing.history.type.expire': 'Expired',
  'billing.history.action.docCreate': 'Create document',
  'billing.history.action.docSnapshot': 'Save version snapshot',
  'billing.history.action.docEdit': 'Edit document',
  'billing.history.action.search': 'Search',
  'billing.history.action.ai': 'AI request',
  'billing.history.action.upload': 'File upload',
  'billing.history.action.import': 'Import',
  'billing.history.action.site': 'Site deploy',
  'billing.history.refundOf': 'Refund: {action}',
  'billing.history.noDescription': 'No description',
  'billing.history.balanceAfter': 'Balance {count}',
  'billing.history.empty': 'No credit transactions yet.',
  'billing.history.emptyFiltered': 'No transactions match these filters.',
  'billing.history.filterProject': 'Project',
  'billing.history.filterAllProjects': 'All projects',
  'billing.history.filterFrom': 'From',
  'billing.history.filterTo': 'To',
  'billing.history.clearFilters': 'Clear filters',
  'billing.history.exportCsv': 'Export CSV',
  'billing.history.exporting': 'Exporting…',
  'billing.history.exportFailed': 'Could not export the credit history: {message}',
  'billing.history.exportHint': 'The export holds up to 10,000 rows matching the filters.',
  'billing.history.col.time': 'Time',
  'billing.history.col.activity': 'Activity',
  'billing.history.col.project': 'Project',
  'billing.history.col.actor': 'By',
  'billing.history.col.credits': 'Credits',
  'billing.history.col.balance': 'Balance after',
  'billing.history.actorApiKey': 'API key: {name}',
  'billing.history.actorApiKeyUnnamed': 'Deleted API key',
  'billing.history.projectDeleted': 'Deleted project',
  'billing.history.settingsTab': 'Credit history',
  'billing.history.settingsDescription': 'Every credit added to or spent by this workspace, with the project and who used it.',
  'billing.history.error': 'Could not load credit history.',
  'billing.history.loadMore': 'Load more',
  'billing.history.showing': 'Showing {shown} of {total}',

  'billing.purchases.empty': 'No credit packs purchased yet.',
  'billing.purchases.error': 'Could not load purchases.',
  'billing.purchases.credits': '+{count} credits',
  'billing.purchases.status.completed': 'Completed',
  'billing.purchases.status.refunded': 'Refunded',
} satisfies Record<string, string>

export const billingVi: Record<keyof typeof billingEn, string> = {
  'billing.title': 'Thanh toán',
  'billing.subtitle': 'Số dư credit, các gói credit và lịch sử sử dụng credit của workspace.',

  'billing.overview.heading': 'Gói & credit',
  'billing.balance.total': 'Tổng số dư',
  'billing.balance.purchased': 'Đã mua',
  'billing.balance.free': 'Miễn phí',
  'billing.balance.credits': '{count} credit',
  'billing.balance.hint': 'Credit miễn phí được dùng trước. Credit đã mua không hết hạn.',
  'billing.balance.error': 'Không tải được số dư credit.',

  'billing.buy.heading': 'Mua credit',
  'billing.buy.popular': 'Phổ biến nhất',
  'billing.buy.credits': '{count} credit',
  'billing.buy.bonus': 'Tặng thêm {count}',
  'billing.buy.buy': 'Mua ngay',
  'billing.buy.buyNamed': 'Mua gói {name}',
  'billing.buy.redirecting': 'Đang chuyển hướng…',
  'billing.buy.packsError': 'Không tải được các gói credit. Vui lòng tải lại trang.',
  'billing.buy.noPacks': 'Hiện chưa có gói credit nào.',
  'billing.buy.footer': 'Thanh toán bằng thẻ được Polar xử lý an toàn. Credit không được hoàn tiền và không hết hạn.',
  'billing.buy.footerWithTransfer':
    'Thanh toán bằng thẻ (USD) được Polar xử lý an toàn; chuyển khoản VietQR (VND) được SePay xác nhận tự động. Credit không được hoàn tiền và không hết hạn.',
  'billing.buy.payCard': 'Thẻ (USD)',
  'billing.buy.payCardNamed': 'Thanh toán gói {name} bằng thẻ (USD)',
  'billing.buy.payTransfer': 'Chuyển khoản VietQR (VND)',
  'billing.buy.payTransferNamed': 'Thanh toán gói {name} bằng chuyển khoản VietQR (VND)',
  'billing.buy.priceVnd': 'hoặc {price} qua chuyển khoản',

  'billing.sepay.title': 'Chuyển khoản: {name}',
  'billing.sepay.creating': 'Đang tạo đơn thanh toán…',
  'billing.sepay.createFailed': 'Không tạo được đơn thanh toán.',
  'billing.sepay.unconfigured': 'Hiện chưa thể thanh toán bằng chuyển khoản.',
  'billing.sepay.retry': 'Thử lại',
  'billing.sepay.scan': 'Quét mã QR bằng ứng dụng ngân hàng, hoặc chuyển khoản thủ công theo thông tin bên dưới. Giữ nguyên nội dung chuyển khoản để hệ thống nhận diện được thanh toán của bạn.',
  'billing.sepay.qrAlt': 'Mã VietQR để thanh toán {amount}',
  'billing.sepay.bank': 'Ngân hàng',
  'billing.sepay.account': 'Số tài khoản',
  'billing.sepay.accountName': 'Chủ tài khoản',
  'billing.sepay.amount': 'Số tiền',
  'billing.sepay.content': 'Nội dung chuyển khoản',
  'billing.sepay.copy': 'Sao chép {label}',
  'billing.sepay.copied': 'Đã sao chép',
  'billing.sepay.expiresIn': 'Hết hạn sau {time}',
  'billing.sepay.expired': 'Đơn này đã hết hạn. Nếu bạn đã chuyển khoản, credit vẫn sẽ được cộng; nếu chưa, hãy tạo đơn mới.',
  'billing.sepay.waiting': 'Đang chờ tiền về… Trạng thái sẽ tự động cập nhật.',
  'billing.sepay.statusError': 'Không kiểm tra được trạng thái thanh toán. Đang thử lại…',
  'billing.sepay.paidTitle': 'Đã nhận thanh toán',
  'billing.sepay.paidBody': 'Đã cộng {credits} credit vào số dư của bạn.',
  'billing.sepay.newOrder': 'Tạo đơn mới',
  'billing.sepay.done': 'Xong',

  'billing.banner.sandboxTitle': 'Chế độ sandbox',
  'billing.banner.sandboxBody': 'Thanh toán dùng môi trường sandbox của Polar nên không bị trừ tiền thật. Hãy dùng thẻ thử nghiệm của sandbox.',
  'billing.banner.successTitle': 'Thanh toán thành công',
  'billing.banner.successBody': 'Credit sẽ sớm được cộng vào số dư. Trang sẽ tự động cập nhật.',
  'billing.banner.cancelTitle': 'Đã hủy thanh toán',
  'billing.banner.cancelBody': 'Bạn chưa bị trừ tiền. Chọn một gói bên dưới để thử lại.',
  'billing.banner.unconfiguredTitle': 'Hệ thống thanh toán chưa được cấu hình',
  'billing.banner.unconfiguredBody': 'Nhà cung cấp thanh toán hiện không khả dụng. Vui lòng liên hệ bộ phận hỗ trợ.',
  'billing.banner.checkoutFailed': 'Thanh toán thất bại',
  'billing.banner.noCheckoutUrl': 'Không nhận được liên kết thanh toán. Vui lòng thử lại.',

  'billing.history.heading': 'Lịch sử credit',
  'billing.history.transactions': 'Giao dịch',
  'billing.history.purchases': 'Lần mua',
  'billing.history.filterLabel': 'Loại giao dịch',
  'billing.history.filterAll': 'Tất cả các loại',
  'billing.history.type.deduct': 'Sử dụng',
  'billing.history.type.purchase': 'Mua',
  'billing.history.type.free_grant': 'Credit miễn phí',
  'billing.history.type.refund': 'Hoàn lại',
  'billing.history.type.expire': 'Hết hạn',
  'billing.history.action.docCreate': 'Tạo tài liệu',
  'billing.history.action.docSnapshot': 'Lưu bản chụp phiên bản',
  'billing.history.action.docEdit': 'Sửa tài liệu',
  'billing.history.action.search': 'Tìm kiếm',
  'billing.history.action.ai': 'Yêu cầu AI',
  'billing.history.action.upload': 'Tải tệp lên',
  'billing.history.action.import': 'Nhập dữ liệu',
  'billing.history.action.site': 'Triển khai site',
  'billing.history.refundOf': 'Hoàn lại: {action}',
  'billing.history.noDescription': 'Không có mô tả',
  'billing.history.balanceAfter': 'Số dư {count}',
  'billing.history.empty': 'Chưa có giao dịch credit nào.',
  'billing.history.emptyFiltered': 'Không có giao dịch nào khớp với bộ lọc.',
  'billing.history.filterProject': 'Dự án',
  'billing.history.filterAllProjects': 'Tất cả dự án',
  'billing.history.filterFrom': 'Từ ngày',
  'billing.history.filterTo': 'Đến ngày',
  'billing.history.clearFilters': 'Xóa bộ lọc',
  'billing.history.exportCsv': 'Xuất CSV',
  'billing.history.exporting': 'Đang xuất…',
  'billing.history.exportFailed': 'Không xuất được lịch sử credit: {message}',
  'billing.history.exportHint': 'Tệp xuất chứa tối đa 10.000 dòng khớp với bộ lọc.',
  'billing.history.col.time': 'Thời gian',
  'billing.history.col.activity': 'Hoạt động',
  'billing.history.col.project': 'Dự án',
  'billing.history.col.actor': 'Người/agent',
  'billing.history.col.credits': 'Credit',
  'billing.history.col.balance': 'Số dư sau',
  'billing.history.actorApiKey': 'API key: {name}',
  'billing.history.actorApiKeyUnnamed': 'API key đã xóa',
  'billing.history.projectDeleted': 'Dự án đã xóa',
  'billing.history.settingsTab': 'Lịch sử credit',
  'billing.history.settingsDescription': 'Mọi khoản credit được cộng vào hoặc sử dụng trong workspace, kèm dự án và người đã dùng.',
  'billing.history.error': 'Không tải được lịch sử credit.',
  'billing.history.loadMore': 'Tải thêm',
  'billing.history.showing': 'Đang hiển thị {shown} trên {total}',

  'billing.purchases.empty': 'Chưa mua gói credit nào.',
  'billing.purchases.error': 'Không tải được lịch sử mua.',
  'billing.purchases.credits': '+{count} credit',
  'billing.purchases.status.completed': 'Hoàn tất',
  'billing.purchases.status.refunded': 'Đã hoàn tiền',
}
